export enum SvgIconNameEnum {
    EDIT_PENCIL = 'pencil',
    FOOTNOTE = 'footnote',
    LOGIC = 'logic',
    OUTLET_PLUG = 'plug',
    PREDICATE_LOGIC_ONE = 'predicate-logic',
    PREDICATE_LOGIC_TWO = 'predicate-logic-2',
    PUZZLE_PIECE = 'puzzle_piece',
    STAR_UNFILLED = 'bootstrap-star',
    STAR_FILLED = 'bootstrap-star-filled',
    STAR_FILLED_BLUE = 'bootstrap-star-filled-blue',
    TRASH_CAN = 'trash',

    IS_NOT_SITE_ADMIN = 'is-not-site-admin',
    IS_SITE_ADMIN = 'is-site-admin',

    MANAGE_ROLES = 'person-fill',
    MANAGE_ROLES_NOT_INHERITED = 'person-fill-blue',
    MANAGE_ROLES_DISABLED = 'person-fill-lightgrey'
}
